import { OptionLike } from "helpers/OptionHelper";
import { BaseModel } from "./BaseModel";
import { ExemptionTypeData } from "./types";

export class ExemptionType extends BaseModel<ExemptionTypeData> {
	id: string;
	name: string;
	description: string;
	detailsUrl: string;
	jurisdictionId: string;

	constructor(data: ExemptionTypeData) {
		super(data);
		this.id = data.id;
		this.name = data.name;
		this.description = data.description;
		this.detailsUrl = data.detailsUrl;
		this.jurisdictionId = data.jurisdictionId;
	}

	toOption = (): OptionLike & ExemptionType => {
		return { ...this, label: this.name, value: this.id };
	};
}
